import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const ProductRoutes: RouteRecordRaw = {
  path: '/product',
  name: 'ProductModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageProductRoute',
      component: () => import('./views/ManageProductView.vue'),
      meta: {
        title: 'محصولات',
      },
    },
    {
      path: 'create',
      name: 'CreateProductRoute',
      component: () => import('./views/ProductUpsertView.vue'),
      meta: {
        title: 'ایجاد محصول جدید',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:productId',
      name: 'EditProductRoute',
      component: () => import('./views/ProductUpsertView.vue'),
      meta: {
        title: 'ویرایش محصول',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:productId',
      name: 'ViewProductRoute',
      component: () => import('./views/ProductUpsertView.vue'),
      meta: {
        title: 'مشاهده محصول',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.product,
  },
}

export default (router: Router) => {
  router.addRoute(ProductRoutes)
}
